/* AUTAVEX — кольори підкладки (лише Comfort) */
(function(){
var D=window.AVO;if(!D)return;
var A='?v=1786369882',B='?v=1786369883',C='?v=1786369905',E='?v=1786369904';
D.LIN=[
 ['\u0427\u043e\u0440\u043d\u0430','#1F2123','FullSizeRender_7f5cc1fa-b1b3-4ccf-842d-8c1f1371f1a9.jpg?v=1786371085'],
 ['\u041c\u043e\u043b\u043e\u0447\u043d\u0430','#F0E9DC','A6C72B54-B18D-4479-ADDA-69DEE230449B.jpg'+A],
 ['\u0421\u0456\u0440\u0430','#7E8388','4CCFBC45-F4D0-4BEF-B639-96CE39C96BC2.jpg'+E],
 ['\u041c\u043e\u043a\u043a\u043e','#8A6A55','1BA86AF7-2862-471D-95AA-5C02FE3DE7D4.jpg'+B],
 ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0430','#6B4A33','1E79E076-CAB0-4674-869F-CC806FC30AAB.jpg'+C],
 ['\u0428\u043e\u043a\u043e\u043b\u0430\u0434','#4A3327','3CF6A104-B86A-47FB-B137-CAFC16D4919E.jpg'+C],
 ['\u0427\u0435\u0440\u0432\u043e\u043d\u0430','#A8232B','C46D26E0-C21E-4355-8074-D69B9A29B0AF.jpg'+A],
 ['\u0411\u043e\u0440\u0434\u043e','#6E2733','049D82D6-B010-4A01-94EB-ECED8E5D9C3B.jpg'+C],
 ['\u0420\u043e\u0436\u0435\u0432\u0430','#E3A9BC','FE0019B1-BCF8-4925-BE8F-6B37B894FE09.jpg'+B],
 ['\u0424\u0443\u043a\u0441\u0456\u044f','#B33C86','C0260F36-BC0B-498D-84C2-C1B68B5D8079.jpg'+B],
 ['\u0424\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0430','#6B4A8C','EACD2562-F794-4EB9-8AFF-4E5C99FC4B38.jpg'+B],
 ['\u041f\u043e\u043c\u0430\u0440\u0430\u043d\u0447\u0435\u0432\u0430','#D2691B','8F084607-4D03-4A14-9364-1EDA3F5C2C49.jpg'+B],
 ['\u0416\u043e\u0432\u0442\u0430','#E3C43A','B2B19F1C-D55D-4825-A4D1-2E511D17B752.jpg'+B],
 ['\u0422\u0435\u043c\u043d\u043e-\u0436\u043e\u0432\u0442\u0430','#C79A1E','3EA67FE8-D330-47E1-A98A-01A30F30E972.jpg'+B],
 ['\u0425\u0430\u043a\u0456','#6E6B47','BE5AAC12-6DC1-450E-888A-567F2E94F47F.jpg'+C],
 ['\u0417\u0435\u043b\u0435\u043d\u0430','#33613D','B5C8E3F3-BFA0-4B78-9461-19EC614DF20F.jpg'+C],
 ['\u0421\u043c\u0430\u0440\u0430\u0433\u0434\u043e\u0432\u0430','#1F7A5A','BEE006B9-039E-4CBE-8BC0-57141CCE4B70.jpg'+C],
 ['\u041c\u02bc\u044f\u0442\u043d\u0430','#8FCBB4','1F9850B1-BF09-4569-94A1-ABDEDB9CCA99.jpg'+B],
 ['\u0413\u043e\u043b\u0443\u0431\u0430','#7FA6C4','6E9EF1AF-9C19-4130-8E64-4458794DDC3A.jpg'+B],
 ['\u0421\u0438\u043d\u044f','#2E5A8C','555F55AA-0247-40B6-A811-4A5607BF70E9.jpg'+C],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0438\u043d\u044f','#1E2C48','8F4DC9ED-8C44-4435-B1EE-10869CBAB20A.jpg'+C]
];
})();
